export class IPharmDashboardRepository {
  async getVisitKpi() {
    throw new Error('Method must be implemented');
  }

  async getPrescriptionKpi() {
    throw new Error('Method must be implemented');
  }

  async getPatients(page, limit) {
    throw new Error('Method must be implemented');
  }

  async getCouponSummary(pharmacyBrn) {
    throw new Error('Method must be implemented');
  }

  async getPointSummary(pharmacyBrn) {
    throw new Error('Method must be implemented');
  }

  async getActionRequiredKpi(pharmacyBrn) {
    throw new Error('Method must be implemented');
  }

  async getRecommendationHits(pharmacyBrn, params) {
    throw new Error('Method must be implemented');
  }

  async getActiveEvents() {
    throw new Error('Method must be implemented');
  }

  async getAdCampaigns() {
    throw new Error('Method must be implemented');
  }

  async setAdCampaignJoin(_campaignId, _join) {
    throw new Error('Method must be implemented');
  }
}
